import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxShoppingIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.3792 19.0049L20.7368 10.6633C20.6576 9.64246 19.8464 9.03046 19.0728 9.03046L18.8128 9.02886C18.752 7.51766 17.5032 6.30646 15.9776 6.30646C15.0864 6.30646 14.2896 6.72006 13.7688 7.36486C13.7104 7.35126 13.6504 7.34006 13.588 7.33126L12.8968 7.32966V6.50166C12.8968 4.62486 11.3696 3.09766 9.49279 3.09766C7.61599 3.09766 6.08879 4.62486 6.08879 6.50166V7.31206L5.35519 7.31046C4.36959 7.31046 3.53599 8.12886 3.45599 9.17366L2.71039 18.7329C2.60079 20.2033 3.78959 20.9337 4.60959 20.9337H19.7152C20.4936 20.9337 20.9432 20.3569 20.9432 20.3569C21.2576 19.9929 21.416 19.5001 21.3784 19.0049H21.3792ZM6.97999 6.50246C6.97999 5.11606 8.10799 3.98886 9.49359 3.98886C10.8792 3.98886 12.0072 5.11686 12.0072 6.50246V7.32806L6.97999 7.31526V6.50246ZM15.0504 19.3737C15.0064 19.4777 14.948 19.5761 14.8824 19.6569L14.8784 19.6617C14.6776 19.8897 14.3992 20.0201 14.1136 20.0201H4.61039C4.31519 20.0201 4.03519 19.8881 3.84319 19.6585C3.64959 19.4337 3.54959 19.1233 3.57039 18.8097L4.30799 9.24406C4.35039 8.66966 4.80719 8.22006 5.34799 8.22006H6.09119V11.1265C6.09119 11.3721 6.29039 11.5721 6.53679 11.5721C6.78319 11.5721 6.98239 11.3729 6.98239 11.1265V8.22006H12.0096V11.1265C12.0096 11.3721 12.2088 11.5721 12.4552 11.5721C12.7016 11.5721 12.9008 11.3729 12.9008 11.1265V8.22006H13.3744C13.9152 8.22006 14.372 8.67046 14.4144 9.24486L14.8216 14.5929L15.068 19.3385L15.0536 19.3729L15.0504 19.3737ZM14.4592 7.70486C14.8408 7.30166 15.3808 7.05046 15.9784 7.05046C17.0936 7.05046 18.008 7.92646 18.0704 9.02646L15.2736 9.01126C15.2736 9.01126 15.0848 8.20566 14.46 7.70486H14.4592Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
